import { render, staticRenderFns } from "./ItemRetirementsListing.vue?vue&type=template&id=6c80dd98"
import script from "./ItemRetirementsListing.vue?vue&type=script&lang=js"
export * from "./ItemRetirementsListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports